import './public-path'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import router from "./router";
import VueClipboards from 'vue-clipboards';

Vue.config.productionTip = false;

Vue.use(VueClipboards);

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
